<script setup lang="ts">
const device = useDevice();

const props = defineProps<{ 
    items: {
        title: string,
        img: string,
        items: {
            title: string,
            icon: string,
            desc: string,
        }[]
    }[],
    isParallaxLocked: boolean
}>();
const desktopRef = useTemplateRef('desktopRef');

const isTransformMobile = computed(() =>
    (desktopRef.value as any)?.isTransformMobile ?? false
);

defineExpose({ isTransformMobile });
</script>

<template>
    <ClientOnly>
        <LazySectionsFeaturesNavaAppMobile 
            v-if="!device.isDesktop.value" 
            :items
        />
        <LazySectionsFeaturesNavaAppDesktop 
            v-else
            ref="desktopRef"
            :items
            :isParallaxLocked
        />
    </ClientOnly>
</template>